/* @ngInject */
const invoicingIcons = () => {
  const self = {}

  self.owner = ''

  return self
}

export default invoicingIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/invoicing/resources/icons.resource.js